import { render, staticRenderFns } from "./ChangePermsShareManager.vue?vue&type=template&id=404113de&scoped=true"
import script from "./ChangePermsShareManager.vue?vue&type=script&lang=js"
export * from "./ChangePermsShareManager.vue?vue&type=script&lang=js"
import style0 from "./ChangePermsShareManager.vue?vue&type=style&index=0&id=404113de&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404113de",
  null
  
)

export default component.exports